import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Avatar, Divider, FormHelperText, FormLabel, Grid, Tab, Tabs, tabsClasses } from "@mui/material";
import moment from 'moment';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import no_address_image from "../../assets/images/no_address.png";
import AppDialog from "../../components/Common/AppDialog";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Table from "../../components/Common/Table";
import CheckBox from "../../components/Form/CheckBox";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import RadioButtonGroupInGrid from "../../components/Form/RadioButtonGroupInGrid";
import Helpers from "../../helpers/helpers";
import { addCustomerPoints, addCustomerVoucher, addNewCustomer, getCustomerDetails, getVoucherList, resetAttachmentState, resetCustomerAttachmentState, resetCustomerState, updateCustomer } from "../../store/actions";
import "../Orders/order.css";
import AddAddress from "./AddAddressModal";
import CustomAutocomplete from "../../components/Form/CustomAutocomplete";

const AddCustomers = ({ type, title, editCustomer, attachment, addCustomer, customerDetails, country, customerAdd, addCustomerVouchers, addCustomerPoint, voucherListing, userPermission, school_list, is_student_portal }) => {
  const { ID } = useParams()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [points, setPointData] = useState({
    customer_id: parseInt(ID),
    points: null,
    remark: "",
    action: "",
    expiry: null,
  });

  const [voucher, setVoucherData] = useState({
    customer_id: ID,
    voucher_id: "",
    active: "",
    expiry: "",
  });

  const fileInputRef = useRef();

  useEffect(() => {
    dispatch(resetCustomerState());
    // dispatch(getVoucherListing({ length: "", page: 1, keyword: "", status: 1, sort: "asc", sort_by: "", discount_type: "" }))
    dispatch(getVoucherList());

    const handleResize = () => {
      setWidth(window.innerWidth); // Update state when window resizes
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
      dispatch(resetCustomerState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [point_sort, setPointSort] = useState("created_at")
  const [point_order, setPointOrder] = useState("desc")
  const [voucher_sort, setVoucherSort] = useState("id")
  const [voucher_order, setVoucherOrder] = useState("desc")
  const [creatable, setCreatable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-customer") && setCreatable(true);
      userPermission?.includes("edit-customer") && setEditable(true);
      !userPermission?.includes("view-customer") && navigate('/not-authorized');

    }
  }, [userPermission])

  const initData = () => {
    dispatch(getCustomerDetails({ id: ID, point_sort: point_sort, point_order: point_order, voucher_sort: voucher_sort, voucher_order: voucher_order }))
  }

  useEffect(() => {
    if (type === "Edit") {
      setIsLoading(true)
      if (ID) {
        initData()
        setIsLoading(false)

      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [point_sort, point_order, voucher_sort, voucher_order]);

  const convertImage = async (img) => {
    return new Promise((resolve) => {
      Helpers.imageToBase64Sync(img, (base64) => {
        setFormValues((prevValues) => ({
          ...prevValues,
          profile_photo: base64
        }))
        resolve();
      });
    });
  };


  useEffect(() => {
    if (type === "Edit") {
      if (ID) {
        const filtered = customerDetails || []
        if (filtered) {
          setFormValues({
            profile_photo: filtered?.profile_photo_path,
            customer_group_id: filtered?.customer_group_id || 0,
            name: filtered.name || "",
            email: filtered.email || "",
            phone: filtered.phone || "",
            dob: filtered.dob ? moment(filtered.dob).format("YYYY-MM-DD") : "",
            country_id: filtered.country_id || "",
            status: filtered.status,
            is_internal_customer: filtered.is_internal_customer,
            school_id: filtered?.school_id || "",
          })
          //need api to get the base64
          setProfileImg(filtered?.profile_photo_path,)
          console.log("fdsfd", filtered)
          if (is_student_portal) {
            setFormValues((prevValues) => ({
              ...prevValues,
              school_id: filtered?.school_id || "",
            }))
          }

          let temp = []
          filtered?.addresses && filtered?.addresses.length > 0 && filtered?.addresses.map((x, idx) =>
            temp.push(
              {
                id: x?.id,
                name: x?.name,
                email: x?.email,
                phone: x?.phone,
                address_line_1: x?.address_line_1,
                address_line_2: x?.address_line_2,
                postal_code: x?.postal_code,
                country_id: x?.country_id,
                city: x?.city,
                state: x?.state,
                default_shipping_address: x?.default_shipping_address,
                company: x?.company,
              },
            ))
          setFormValues((prevValues) => ({
            ...prevValues,
            address: temp
          }));
          setAddressList(temp)
        }
      }
    }
  }, [customerDetails, is_student_portal, customerDetails?.school_id]);

  useEffect(() => {
    if (type === "Edit") {
      if (editCustomer.code === "success") {
        setNotification({
          open: true,
          msg: "Updated Successfully",
          type: "success",
        })
        dispatch(resetAttachmentState())
        dispatch(resetCustomerState())
        initData()
      } else if (editCustomer.code === "error") {
        setNotification({
          open: true,
          msg: editCustomer.message,
          type: "warning",
        })
        dispatch(resetCustomerState())
      }
    }
  }, [editCustomer]);

  useEffect(() => {
    if (customerAdd?.[0]?.address?.[0] === "The address field is required.") {
      setNotification({
        open: true,
        msg: "Please complete the shipping address",
        type: "warning",
      })
      dispatch(resetCustomerAttachmentState())
    } else if (customerAdd?.[0]?.customer_id) {
      setNotification({
        open: true,
        msg: "Please add the customer first",
        type: "warning",
      })
      dispatch(resetCustomerAttachmentState())
    }
  }, [customerAdd]);


  useEffect(() => {
    if (type === "Add") {
      if (addCustomer.code === "success") {
        setNotification({
          open: true,
          msg: "Added Successfully",
          type: "success",
        })
        dispatch(resetCustomerState())
        dispatch(resetAttachmentState())
        navigate("/customer")
      } else if (addCustomer.code === "error") {
        setNotification({
          open: true,
          msg: addCustomer.message,
          type: "warning",
        })
        dispatch(resetCustomerState())
      }
    }
  }, [addCustomer]);

  useEffect(() => {
    if (addCustomerPoint.code === "success") {
      setNotification({
        open: true,
        msg: "Added Successfully",
        type: "success",
      })
      setPointData({
        customer_id: ID,
        points: "",
        remark: "",
        action: "",
        expiry: "",
      });
      dispatch(resetCustomerState())
      initData()
    }
  }, [addCustomerPoint]);

  useEffect(() => {
    if (addCustomerVouchers.code === "success") {
      setNotification({
        open: true,
        msg: "Added Successfully",
        type: "success",
      })
      setVoucherData({
        customer_id: ID,
        voucher_id: "",
        active: "",
        expiry: "",
      });
      dispatch(resetCustomerState())
      initData()
    }
  }, [addCustomerVouchers]);

  const defaultValues = {
    name: "",
    email: "",
    phone: "",
    address: [],
    nationality: "",
    nationality_id: "-1",
    address_line_1: "",
    address_line_2: "",
    postal_code: "",
    city: "",
    state: "",
    state_id: "",
    country_id: "",
    country_name: "",
    customer_group_id: "0",
    is_internal_customer: 0,
    school_id: "",
    dob: "",
    profile_photo: "",
    status: 1
  }

  const [loading, setIsLoading] = useState(false);
  const [addressAction, setAddressAction] = useState('add');
  const [selectedAddress, setSelectedAddress] = useState();
  const [selectedAddressID, setSelectedAddressID] = useState("");
  const [addressList, setAddressList] = useState([]);
  const [isNoEndDate, setIsNoEndDate] = useState(false);
  const [sort, setSorted] = useState('desc');
  const [sort_by, setSortBy] = useState('');
  const [addAddressOpen, setAddAddressOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [values, setFormValues] = useState(defaultValues);
  const [profileImg, setProfileImg] = useState();
  const [addressError, setAddressError] = useState(false);
  const [dateKey, setDateKey] = useState(0);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });

  const onChangeFile = (file) => {
    if (Helpers.isFileSizeValid(file)) {
      Helpers.getBase64(file, (result) => {
        setProfileImg(`data:image/jpeg;base64,${result}`);
        setFormValues((prevValues) => ({
          ...prevValues,
          profile_photo: `data:image/jpeg;base64,${result}`
        }));
      });
    } else {
      setNotification({
        open: true,
        msg: "File size must be less than 1MB",
        type: 'warning'
      });
    }
    // Clear the upload file value
    fileInputRef.current.value = '';
  };

  const data = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ]

  const customerGroup = [
    { label: "VIP", value: 2 },
    { label: "Standard", value: 1 },
  ]

  const actionList = [
    { label: "Add points", value: "add_point" },
    { label: "Deduct points", value: "deduct_point" },
  ]

  const error = customerAdd?.[0];

  const handleSubmit = async (type) => {
    let count = 0
    convertImage(values?.profile_photo)
    if (count <= 1 || values?.address?.length <= 0) {
      if (type === "Add") {
        dispatch(addNewCustomer(values))
      }
      else if (type === "Edit") {
        dispatch(updateCustomer({ id: ID, customer: values }))
      }
    }
  }

  const handleSubmitPoint = () => {
    dispatch(addCustomerPoints({ customer: points }))
  }

  const handleSubmitVoucher = () => {
    dispatch(addCustomerVoucher({ customer: voucher }))
  }

  const handleDeleteAddress = (type) => {
    let temp = addressList && addressList?.length > 0 && addressList.filter((x, idx) =>
      idx !== parseInt(selectedAddressID)
    )
    setAddressList(temp)
    setDeleteOpen(false)
    setFormValues((prevValues) => ({
      ...prevValues,
      address: temp,
    }))
  }

  const handleSetSelectedAddress = (data, id) => {
    setSelectedAddress(data)
    setSelectedAddressID(id)
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleDobChange = (date) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      dob: date === "Invalid date" ? null : moment(date).format("YYYY-MM-DD"),
    }));
  }

  const header = [
    {
      Header: "Date/Time",
      columnID: "created_at",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.created_at ? moment(cellProps.created_at).format("DD/MM/YYYY") : '-'}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Notes",
      columnID: "remark",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.remark || '-'}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Amount",
      columnID: "amount",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.amount || '0'}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Used",
      columnID: "used_amount",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}> {cellProps?.used_amount ? cellProps.used_amount : "0"}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      accessor: (cellProps) => (
        <React.Fragment>
          <Label.StatusLabel label={cellProps?.status === 1 ? "Active" : "Inactive"} marginLeft={"0px"} />
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Expiry",
      columnID: "expiry",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.expiry ? moment(cellProps.expiry).format("DD/MM/YYYY") : '-'}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
  ];
  const voucherHeader = [
    {
      Header: "Voucher",
      columnID: "voucher_id",
      accessor: (cellProps) => (
        <React.Fragment>
          {Helpers.getValueFromData(voucherListing, cellProps?.voucher_id, "name")}
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      columnID: "status",
      accessor: (cellProps) => (
        <React.Fragment>
          <Label.StatusVoucherLabel label={cellProps?.status} marginLeft={"0px"} />
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Active",
      columnID: "active",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.active ? moment(cellProps?.active).format("DD/MM/YYYY") : '-'}</div>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px", color: "#a6a6a6" }}> {cellProps?.active ? moment(cellProps?.active).format("hh:mm A") : ''}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Expiry",
      columnID: "expiry",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.expiry ? moment(cellProps?.expiry).format("DD/MM/YYYY") : '-'}</div>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px", color: "#a6a6a6" }}> {cellProps?.expiry ? moment(cellProps?.expiry).format("hh:mm A") : ''}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Redeemed",
      columnID: "redeemed",
      accessor: (cellProps) => (
        <React.Fragment>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.redeemed ? moment(cellProps?.redeemed).format("DD/MM/YYYY") : '-'}</div>
          <div className="d-flex align-items-center" style={{ paddingRight: "5px", color: "#a6a6a6" }}> {cellProps?.redeemed ? moment(cellProps?.redeemed).format("hh:mm A") : ''}</div>
        </React.Fragment>
      ),
      disableFilters: true,
      filterable: false,
    },
  ];

  const deleteModal = () => {
    return (
      <AppDialog
        open={deleteOpen}
        close={() => setDeleteOpen(false)}
        titleIcon={'error'}
        title={'Delete address'}
        positiveTitle={'Delete'}
        positiveButtonStyle={{ backgroundColor: '#44d62c', color: 'white', border: '1px solid #44d62c' }}
        positivePress={() => handleDeleteAddress()}
        negativeTitle={'Cancel'}
        negativePress={() => setDeleteOpen(false)}
        width={'30%'}
      >
        <div className="subheader mb-3">Are you sure you want to delete this address?</div>
        {
          selectedAddress &&
          <>
            <div className="subheader">{selectedAddress?.name || '-'}</div>
            <div className="subheader-2 mt-1">{selectedAddress?.address_line_1 || ''}</div>
            <div className="subheader-2 mt-1">{selectedAddress?.address_line_2 || ''}</div>
            <div className="subheader-2 mt-1">{Helpers.getValueFromData(country, selectedAddress?.country_id, "name") || ''} {selectedAddress?.postal_code || ''}</div>
          </>
        }
      </AppDialog>
    )
  }

  const renderGeneralTab = () => {
    return (
      <Grid container spacing={2}>
        <Grid item sm={12} lg={8} pb={3}>
          <Card className="p-3 px-2">
            <CardBody>
              <div className="setting-header">BASIC INFO</div>
              <Divider className="my-2 mb-4" />
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} md={6}>
                  <RadioButtonGroupInGrid
                    title={'Customer Group'}
                    value={values?.customer_group_id}
                    data={customerGroup}
                    setValue={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      customer_group_id: e,
                    }))}
                    required="true"
                    name="customer_group_id"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.customer_group_id || ""}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <CustomTextField
                    title={'Name'}
                    values={values?.name}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      name: e
                    }))}
                    placeholder="Name"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.name || ""}</FormHelperText>}
                </Grid>
                {is_student_portal && <Grid item xs={12} sm={12}>
                  <CustomSelect
                    title={'School (Optional)'}
                    values={values?.school_id}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      school_id: e
                    }))}
                    data={school_list}
                    placeholder="School"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.school_id || ""}</FormHelperText>}
                </Grid>}
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    title={'Email address'}
                    values={values?.email}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      email: e
                    }))}
                    placeholder="Email"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.email || ""}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    title={'Phone number'}
                    values={values?.phone}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      phone: e
                    }))}
                    type="phone"
                    placeholder="Eg. 65123456789"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.phone}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomizedDatePicker
                    title={'Date of Birth (Optional)'}
                    values={values?.dob && new Date(values.dob)}
                    setFormValues={(e) => handleDobChange(e)}
                    rerenderKey={dateKey}
                    maxDate={new Date(moment().subtract(18, 'years').toDate())}
                  // name={'dob'}
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.dob || ""}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomAutocomplete
                    title={'Country'}
                    error={error && !values?.country_id && "The country field is required."}
                    values={values?.country_id}
                    data={country}
                    placeholder={'Please select'}
                    onChange={(e, value) => setFormValues((prevValues) => ({
                      ...prevValues,
                      country_id: value?.id
                    }))}
                    valueName={"id"}
                    labelName={"name"}
                  />
                  {/* {error && <FormHelperText sx={{ color: "red" }}>{er</Grid>ror.country_id || ""}</FormHelperText>} */}
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
        <Grid container item sm={12} lg={4}>
          <Grid item xs={12} sm={12}>
            <Card className="p-3 px-2">
              <CardBody>
                <div className="setting-header">SETTINGS</div>
                <Divider className="my-2 mb-4" />
                <FormLabel style={{ fontFamily: 'Manrope-Semibold', fontSize: 14 }}>Avatar</FormLabel>
                <Grid container display={'flex'} alignItems={'center'} justifyContent={'center'} spacing={2}>
                  <Grid item lg={3} sm={1} display={'flex'} justifyContent={'center'}>
                    <Avatar alt="Profile Pic" src={profileImg && `${profileImg}`} sx={{ width: 64, height: 64, backgroundColor: "#F5F6FA", color: "#D0D0D0" }} >
                      {
                        !profileImg && <i className="ri-image-2-fill" style={{ fontSize: 35 }}></i>
                      }
                    </Avatar>
                  </Grid>
                  <Grid item lg={9} sm={11}>
                    <div className="d-flex mb-2">
                      <CustomButton
                        title={'Choose'}
                        press={() => document.getElementById("new-upload-file").click()}
                        backgroundColor={'#F2F2F2'}
                        textColor={'#101010'}
                        borderStyle={'1px solid #E3E8EE'}
                      />
                      {
                        profileImg &&
                        <CustomButton
                          title={'Remove'}
                          press={() => setProfileImg()}
                          backgroundColor={'white'}
                          textColor={'#101010'}
                          borderStyle={'1px solid #E3E8EE'}
                          marginLeft={5}
                        />
                      }
                      <input
                        type="file"
                        id={"new-upload-file"}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        accept="image/png, image/jpeg"
                        onChange={(e) => onChangeFile(e.target.files[0])}
                      />
                    </div>
                    <div className="setting-desc">JPG or PNG, 1MB Max.</div>
                    {error && <FormHelperText sx={{ color: "red" }}>{error.profile_photo || ""}</FormHelperText>}
                  </Grid>
                </Grid>
                <div className="mt-3 mb-2">
                  <RadioButtonGroupInGrid
                    title={'Account status'}
                    value={values?.status}
                    data={data}
                    setValue={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      status: e,
                    }))}
                    required="true"
                    name="status"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                </div>
                {is_student_portal && <div className="mt-3 mb-2">
                  <CheckBox
                    label={'Is Internal Customer'}
                    values={values?.is_internal_customer == 1 ? true : false}
                    onChange={(e) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        is_internal_customer: e?.target?.checked ? 1 : 0,
                      }))
                    }}
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.is_internal_customer || ""}</FormHelperText>}
                </div>}
                {type === "Edit" &&
                  <>
                    <FormLabel style={{ fontFamily: 'Manrope-Semibold', fontSize: 14 }}>Points balance</FormLabel>
                    <div><span style={{ marginRight: 5, fontFamily: 'Manrope-SemiBold' }}>{customerDetails?.point_balance}</span>points</div>
                  </>
                }
                {type === "Edit" &&
                  <>
                    <FormLabel className={'mt-3'} style={{ fontFamily: 'Manrope-Semibold', fontSize: 14 }}>Last logged in</FormLabel>
                    <div>{customerDetails?.last_logged_in ? <>{moment(customerDetails?.last_logged_in).format("DD MMM YYYY")}, {moment(customerDetails?.last_logged_in).format("hh:mm A")}</> : "-"}</div>
                  </>
                }
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  const renderAddressTab = () => {
    return (
      <Card className="p-3 px-2">
        <CardBody>
          <div className="setting-header">ADDRESSES</div>
          <Divider className="my-2 mb-4" />
          <Grid container spacing={2} >
            {
              !addressList &&
              <Grid item sm={12} py={2}>
                <div className="d-flex justify-content-center"><img src={no_address_image} alt="no-address-set" style={{ height: 120, width: 120 }} /></div>
                <div className="d-flex justify-content-center" style={{ color: '#999999' }}>No address set.</div>
              </Grid>
            }
            {
              addressList && addressList.map((el, index) => {
                return (
                  <Grid item xs={12} md={6} >
                    <Grid container className="curve-container">
                      <Grid item xs={10} sm={8}>
                        <div className="subheader">{el?.name || '-'}</div>
                        <div className="subheader-2 mt-1">{el?.address_line_1 || ''}</div>
                        <div className="subheader-2 mt-1">{el?.address_line_2 || ''}</div>
                        <div className="subheader-2 mt-1">{el?.country || ''} {el?.postal_code || ''}</div>
                      </Grid>
                      <Grid item xs={2} sm={4} textAlign={'right'}>
                        <CustomIconButton
                          iconName={'ri-pencil-line'}
                          onClick={() => { setAddressAction('Edit'); handleSetSelectedAddress(el, index); setAddAddressOpen(true) }}
                        />
                        {el?.default_shipping_address === 1 ?
                          ""
                          :
                          <CustomIconButton
                            iconName={'ri-delete-bin-line'}
                            color={'white'}
                            backgroundColor={'var(--bs-theme-color)'}
                            borderStyle={'1px solid var(--bs-theme-color)'}
                            onClick={() => { handleSetSelectedAddress(el, index); setDeleteOpen(true) }}
                          />}
                      </Grid>
                      {
                        el?.default_shipping_address === 1 &&
                        <Grid item xs={12} mt={1}>
                          <Label.CustomLabel backgroundColor={'#F1F1F1'} color={'#101010'} label={'Default'} />
                        </Grid>
                      }
                    </Grid>
                  </Grid>
                )
              })
            }
          </Grid>
          {(creatable || editable) && <div className="mt-4">
            <CustomButton
              title={'Add Shipping Address'}
              borderStyle={'1px solid #101010'}
              press={() => { setAddressAction('Add'); setAddAddressOpen(true); setSelectedAddress() }}
            />
          </div>}
        </CardBody>
      </Card>
    )
  }

  const renderPointsTab = () => {
    return (
      <Grid container spacing={2} >
        <Grid item xs={12} md={8}>
          <Card className="p-3 px-2">
            <CardBody>
              <Grid container mb={2} >
                <Grid item xs={12} sm={3} fontSize={14}>Points balance</Grid>
                <Grid item xs={12} sm={9} fontSize={16}><span className="label-title">{customerDetails?.point_balance || 0}</span> points</Grid>
              </Grid>
              <Table
                header={header}
                data={customerDetails?.pointHistories}
                pageSize={customerDetails?.pointHistories?.length + 1}
                totalPage={1}
                customToolsBar={true}
                sort_by={point_sort}
                setSortBy={setPointSort}
                sort={point_order}
                setSorted={setPointOrder}
              />
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Grid container item sm={12}>
            <Grid item xs={12}>
              <Card className="p-3 px-2">
                <CardBody>
                  <div className="setting-header">MANAGE POINTS</div>
                  <Divider className="my-2 mb-4" />
                  <CustomTextField
                    title={'Points amount'}
                    values={points?.points || ""}
                    onChange={(e) => setPointData((prevValues) => ({
                      ...prevValues,
                      points: e ? parseInt(e) : e
                    }))}
                    type="number"
                    placeholder="0.00"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.points || ""}</FormHelperText>}
                  <div className="mt-3">
                    <CustomTextField
                      title={'Notes'}
                      values={points?.remark}
                      onChange={(e) => setPointData((prevValues) => ({
                        ...prevValues,
                        remark: e
                      }))}
                      multiline={true}
                      rows={4}
                    />
                    {error && <FormHelperText sx={{ color: "red" }}>{error.remark || ""}</FormHelperText>}
                  </div>
                  <div className="mt-3">
                    <CustomSelect
                      title={'Action'}
                      values={points?.action || '-1'}
                      data={actionList}
                      placeholder={'Please select'}
                      onChange={(e) => setPointData((prevValues) => ({
                        ...prevValues,
                        action: e
                      }))}
                    />
                    {error && <FormHelperText sx={{ color: "red" }}>{error.action || ""}</FormHelperText>}
                  </div>
                  {
                    points?.action !== "deduct_point" &&
                    <div className="mt-3">
                      <CustomTextField
                        title={'Expiry (days)'}
                        values={points?.expiry || ""}
                        type={"number"}
                        onChange={(e) => setPointData((prevValues) => ({
                          ...prevValues,
                          expiry: parseInt(e)
                        }))}
                        placeholder={'0'}
                      />
                      {error && <FormHelperText sx={{ color: "red" }}>{error.expiry || ""}</FormHelperText>}
                    </div>
                  }
                  <div className="mt-3">
                    <CustomButton
                      title={'Save'}
                      width={'100%'}
                      press={(e) => handleSubmitPoint()}
                      backgroundColor={'#101010'}
                      textColor={'white'}
                    />
                  </div>
                </CardBody>
              </Card>
            </Grid>
          </Grid>
        </Grid>

      </Grid >
    )
  }

  const renderVoucherTab = () => {
    return (
      <Grid container spacing={2} >
        <Grid item xs={12} md={8}>
          <Card className="p-3 px-2">
            <CardBody>
              <Table
                header={voucherHeader}
                data={customerDetails?.vouchers}
                pageSize={customerDetails?.vouchers?.length + 1}
                totalPage={1}
                customToolsBar={true}
                sort_by={voucher_sort}
                setSortBy={setVoucherSort}
                sort={voucher_order}
                setSorted={setVoucherOrder}
              />
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Grid container item sm={12}>
            <Grid item xs={12} sm={12}>
              <Card className="p-3 px-2">
                <CardBody>
                  <div className="setting-header">ASSIGN VOUCHER</div>
                  <Divider className="my-2 mb-4" />
                  <CustomSelect
                    title={'Voucher'}
                    valueName={"id"}
                    labelName={"name"}
                    values={voucher?.voucher_id || "-1"}
                    data={voucherListing}
                    placeholder={'Select voucher'}
                    onChange={(e) => setVoucherData((prevValues) => ({
                      ...prevValues,
                      voucher_id: e
                    }))}
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.voucher_id || ""}</FormHelperText>}
                  <div className="mt-3">
                    <CustomizedDatePicker
                      title={'Active'}
                      values={voucher?.active && new Date(voucher?.active)}
                      setFormValues={setVoucherData}
                      name={'active'}
                    />
                    {error && <FormHelperText sx={{ color: "red" }}>{error.active || ""}</FormHelperText>}
                  </div>
                  <div className="mt-3">
                    <CustomizedDatePicker
                      title={'Expiry'}
                      values={voucher?.expiry && new Date(voucher?.expiry)}
                      disabled={isNoEndDate}
                      setFormValues={setVoucherData}
                      name={'expiry'}
                    />
                    {error && <FormHelperText sx={{ color: "red" }}>{error.expiry || ""}</FormHelperText>}
                  </div>
                  <div className="mt-3">
                    <CheckBox label={'No end date'} values={isNoEndDate} onChange={(e) => {
                      setIsNoEndDate(e.target.checked);
                      setVoucherData((prevValues) => ({
                        ...prevValues,
                        expiry: ""
                      }))
                    }} />
                  </div>
                  <div className="mt-3">
                    <CustomButton
                      title={'Save'}
                      width={'100%'}
                      backgroundColor={'#101010'}
                      textColor={'white'}
                      press={() => handleSubmitVoucher()}
                    />
                  </div>
                </CardBody>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  const handleSubmitAddress = (type, selectedIDX) => {
    if (selectedAddress?.name && selectedAddress?.address_line_1 && selectedAddress?.postal_code && selectedAddress?.country_id && selectedAddress?.city && selectedAddress?.phone) {
      setAddressError(false)
      if (Helpers?.phoneLengthValidation(selectedAddress?.phone)) {
        if (type === "Edit") {
          setAddressList((prevAddressList) =>
            prevAddressList.map((item, idx) => {
              if (idx === selectedIDX) {
                return { ...selectedAddress };
              } else if (selectedAddress.default_shipping_address === 1) {
                return { ...item, default_shipping_address: 0 };
              }
              return item;
            })
          );

          setFormValues((prevValues) => ({
            ...prevValues,
            address: prevValues.address.map((item, idx) => {
              if (idx === selectedIDX) {
                return { ...selectedAddress };
              } else if (selectedAddress.default_shipping_address === 1) {
                return { ...item, default_shipping_address: 0 };
              }
              return item;
            })
          }));
          setAddAddressOpen(false)

          // if (selectedAddress?.default_shipping_address === 1) {
          //   let updatedAddressList = addressList.map((item, idx) => {
          //     if (item.default_shipping_address === 1 && idx !== selectedIDX) {
          //       return { ...item, default_shipping_address: 0, };
          //     } else if (idx === selectedIDX) {
          //       return { ...item, default_shipping_address: 1 };
          //     }
          //     return item;
          //   });
          //   setAddressList(updatedAddressList);
          //   setFormValues((prevValues) => ({
          //     ...prevValues,
          //     address: updatedAddressList,
          //   }));
          // }
        }
        if (type === "Add") {
          let temp = addressList
          temp.push(selectedAddress)

          if (selectedAddress?.default_shipping_address === 1) {
            let updatedAddressList = temp.map((item, idx) => {
              if (item.default_shipping_address === 1 && idx !== (temp.length - 1)) {
                return { ...item, default_shipping_address: 0 };
              } else if (idx === (temp.length - 1)) {
                return { ...item, default_shipping_address: 1 };
              }
              return item;
            });
            setAddressList(updatedAddressList);
            setFormValues((prevValues) => ({
              ...prevValues,
              address: updatedAddressList,
            }));
          } else {
            setFormValues((prevValues) => ({
              ...prevValues,
              address: temp
            }));
          }
          setAddAddressOpen(false)
        }
      } else {
        setNotification({
          open: true,
          msg: "Phone number is invalid!",
          type: "warning",
        })
      }
    } else {
      setAddressError(true)
      setNotification({
        open: true,
        msg: "Please complete the address",
        type: "warning",
      })
    }

  }
  return (
    <React.Fragment>
      {
        width <= 425 &&
        <div className="mobile-button-container">
          <CustomButton
            title={type === 'Add' ? 'Save' : 'Save Changes'}
            press={() => handleSubmit(type)}
            height={40}
            backgroundColor={'#101010'}
            textColor={'white'}
            width={'100%'}
          />
        </div>
      }
      <div className="page-content">
        <LoadingDialog open={loading || (type === "Edit" && !customerDetails)} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Breadcrumbs
            title={title}
            backRoute={"/customer"}
            breadcrumbItems={[{ title: "Customers", link: "/customer" },
            { title: title, link: "#" },
            ]}
          >
            {
              width > 425 &&
              <CustomButton
                title={type === 'Add' ? 'Save' : 'Save Changes'}
                press={() => handleSubmit(type)}
                height={40}
                backgroundColor={'#101010'}
                textColor={'white'}
              />
            }
          </Breadcrumbs>
          <div className="mb-2" >
            <Tabs
              variant="scrollable"
              value={tabValue}
              onChange={(e, val) => setTabValue(val)}
              aria-label="basic tabs example"
              TabIndicatorProps={{ style: { backgroundColor: 'var(--bs-theme-color)' } }}
            >
              <Tab label={<div className="d-flex" style={{ color: tabValue === 0 ? '#282828' : '#A0A0A0' }}>General</div>} {...a11yProps(0)} />
              <Tab label={<div className="d-flex" style={{ color: tabValue === 1 ? '#282828' : '#A0A0A0' }}>Address</div>} {...a11yProps(1)} />
              <Tab label={<div className="d-flex" style={{ color: tabValue === 2 ? '#282828' : '#A0A0A0' }}>Points</div>} {...a11yProps(2)} />
              <Tab label={<div className="d-flex" style={{ color: tabValue === 3 ? '#282828' : '#A0A0A0' }}>Vouchers</div>} {...a11yProps(3)} />
            </Tabs>
          </div>
          {tabValue === 0 && renderGeneralTab()}
          {tabValue === 1 && renderAddressTab()}
          {tabValue === 2 && renderPointsTab()}
          {tabValue === 3 && renderVoucherTab()}
          {deleteModal()}
          <AddAddress
            creatable={creatable}
            editable={editable}
            open={addAddressOpen}
            close={() => { setAddAddressOpen(false); setAddressError(false) }}
            type={addressAction}
            country={country}
            error={addressError}
            setFormValues={setSelectedAddress}
            handleSubmitAddress={handleSubmitAddress}
            selectedAddressID={selectedAddressID}
            formValues={selectedAddress}
          />
        </Container>

      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ Customer, General, Login, Voucher }) {
  return {
    customerDetails: Customer.customerDetails,
    voucherListing: General.voucherList.data,
    addCustomerVouchers: Customer.addCustomerVouchers,
    addCustomerPoint: Customer.addCustomerPoint,
    customerAdd: Customer.error,
    addCustomer: Customer.addCustomer,
    school_list: General.active_schools,
    is_student_portal: General.is_student_portal,
    editCustomer: Customer.editCustomer,
    country: General.countries,
    countryWithoutMlys: General.countries.filter((el) => el.id != 129),
    userData: Login?.verifyAdmin?.user?.data,
    attachment: General.attachment,
    userPermission: Login.permissionArry,
  };
}


export default connect(mapStateToProps)(AddCustomers);
